// Lazy load function
const lazyLoad = (file) => () =>
    import(
    /* webpackChunkName: "[request]" */ `@/views/settings/sales/${file}.vue`
    );

export default [
    // Settings - Pallet Type
    {
        path: "/pallet-type",
        name: "pallet-type",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "PalletType",
        },
        components: {
            content: lazyLoad("pallet-type"),
        },
    },
    {
        path: "/pallet-type/review/:id",
        name: "pallet-type-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "PalletType",
        },
        components: {
            content: lazyLoad("pallet-type"),
        },
    },
    {
        path: "/pallet-type/edit/:id",
        name: "pallet-type-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "PalletType",
        },
        components: {
            content: lazyLoad("pallet-type"),
        },
    },
    {
        path: "/pallet-type/create",
        name: "pallet-type-create",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "PalletType",
        },
        components: {
            content: lazyLoad("pallet-type"),
        },
    },
];
